import React from 'react'
import AuctionDetailsComp from '../Components/auctiondetailssection/AuctionDetailsComp'


function AuctionDetails() {
  return (
    <>
   <AuctionDetailsComp />
    </>
  )
}

export default  AuctionDetails